export const FILTERS_NO_RESULTS: {
  [key: string]: string;
} = {
  EN: 'No result. Please try again with different search parameters.',
  FR: 'Aucun résultat. Veuillez ré-essayer en changeant les paramètres de recherche.',
};
